import React, {useState} from 'react';
import {Modal} from 'semantic-ui-react'
import { useDispatch, useSelector } from 'react-redux';
import {CardGridActions} from '../../actions/CardGridAction'
import { Formik, Field, Form } from 'formik';



const MoreFilters = (props) => {


    const [open, setOpen] = useState(false)
    const dispatch = useDispatch();
    const cardData = useSelector(state => state.cardGrid)


    const renderTriggerButton = () => {
            return <button className="ui inverted green button">More Filters</button>
    }

    const onFilterSubmit = (values) => {
        setOpen(false)
        //pass an event ot the cardGrid telling it to apply the new filters
        console.log(values)
        dispatch(CardGridActions.applyAdditionalFilters(values))  //Add in Filtering logic
    }

    return (
        <Modal
            onClose={() => setOpen(false)}
            onOpen={() => setOpen(true)}
            open={open}
            trigger={renderTriggerButton()}
        >
        <Modal.Header>Additional Filters</Modal.Header>
            <Modal.Content >
            <Formik
                        initialValues={{
                            showSold: cardData && cardData.additionalFilters ? cardData.additionalFilters.showSold : false,
                            includeCompleteSets: cardData && cardData.additionalFilters ? cardData.additionalFilters.includeCompleteSets : true,
                            setFilter: cardData && cardData.additionalFilters ? cardData.additionalFilters.setFilter : 'N/A',
                        }}
                        
                        onSubmit={ values => {onFilterSubmit(values)}}
                        >
                        {({ values }) => (
                            
                            <Form className="ui form"> 
                                <h4 className="ui dividing header">Filters</h4>
                                    
                                <div className="three fields">
                                <div className="field">
                                    <label>Show Sold Cards?</label>
                                    <Field type="checkbox" className="field" id="showSold" name="showSold" placeholder="" />
                                </div>
                                <div className="field">
                                    <label>Include Complete Sets?</label>
                                    <Field type="checkbox" className="field" id="includeCompleteSets" name="includeCompleteSets"  />
                                </div>
                                    <div className="field">
                                        <label>View a Complete Set</label>
                                        <Field as="select" className="field" id="setFilter" name="setFilter" placeholder="N/A" >
                                            <option value="N/A">N/A</option>
                                            {cardData.sets.map(setItem =>
                                            <option key={setItem} value={setItem}>{setItem}</option>
                                         )};
                                        </Field>
                                    </div>
                                </div>
                                <button className="ui basic blue button" type="submit">Apply Filters</button>
                            </Form>
                        )}
                </Formik>

            </Modal.Content>

        </Modal>
    )
       
    
}
export default MoreFilters